export const def = (x: any) => typeof x !== 'undefined';

export const isArray = (x: any) => Array.isArray(x);

export const flatten = ([x, ...xs]: any[]) =>
  def(x)
    ? isArray(x)
      ? [...flatten(x), ...flatten(xs)]
      : [x, ...flatten(xs)]
    : [];

export const prettyMobile = mobile =>
  `(${mobile.substring(0, 3)})${mobile.substring(3, 6)}-${mobile.substring(
    6,
    10,
  )}`;

export const prettyTimestamp = timestamp => {
  const dateObject = timestamp.toDate();
  const month = dateObject.getMonth() + 1;
  const date = dateObject.getDate();
  const year = dateObject.getFullYear();
  const hour =
    dateObject.getHours() > 12
      ? dateObject.getHours() - 12
      : dateObject.getHours();
  const amPm = dateObject.getHours() >= 12 ? 'pm' : 'am';
  const minute =
    dateObject.getMinutes() < 10
      ? '0' + dateObject.getMinutes()
      : dateObject.getMinutes();

  return `${month}/${date}/${year} ${hour}:${minute + amPm}`;
};



// WEBPACK FOOTER //
// ./src/components/methods.ts